export const StorageServiceKeysMap = {
  UserProfile: 'userProfile',
  PendingLastVisitedUrl: 'pendingLastVisitedUrl',
  KycOverviewFilter: 'kycOverviewFilter',
  KycWorkItemList: 'kycWorkItemList',
  User: 'user',
  LogoutReason: 'logoutReason',
  OrganizationId: 'organizationId',
  OwnGrants: 'ownGrants',
  Organizations: 'organizations',
  GrantLoadingComplete: 'grantLoadingComplete',
  WorkItemTypes: 'workItemTypes',
  TimeoutWarning: 'timeoutWarning',
  Contract: 'contract',
  AccessTokenKerberos: 'accessTokenKerberos',
  RefreshTokenKerberos: 'refreshTokenKerberos',
  KycOverviewWorkItems: 'kycOverviewWorkItems',
  KycCreateViewWorkItem: 'kycCreateViewWorkItem',
  AccessTokenHanko: 'accessTokenHanko',
  AuthSource: 'authSource',
  LaCreateViewState: 'laCreateViewState',
  WorkItemCommunicationDrafts: 'workItemCommunicationDrafts',
  ShowMaintenanceNotice: 'maintenanceNotice',
  TrainingListFilter: 'trainingListFilter',
  IsImpersonated: 'isImpersonated',
  ImpersonationContext: 'impersonationContext',
  DocumentLibraryFilter: 'documentLibraryFilter',
  RiskAnalysisDocumentFilter: 'riskAnalysisDocumentFilter',
  SessionExpiryTimestamp: 'sessionExpiryTimestamp',
  SecurityNudgeDismissedAt: 'securityNudgeDismissedAt',
  RecentOrganizations: 'recentOrganizations',
} as const;

export type StorageServiceKeys = (typeof StorageServiceKeysMap)[keyof typeof StorageServiceKeysMap];
